import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./FrequencySelectorStyles";
import { energyActions } from "../_actions";

export default class FrequencySelector extends Component {
  render() {
    const {
      energy: { usageFrequency }
    } = this.props;
    return (
      <div className={css(styles.selectorWrapper)}>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            this.props.dispatch(energyActions.setUsageFrequency("timeline"))
          }
        >
          <p
            className={css(
              styles.selector,
              usageFrequency === "timeline" && styles.selected
            )}
          >
            Timeline
          </p>
        </span>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            this.props.dispatch(energyActions.setUsageFrequency("day"))
          }
        >
          <p
            className={css(
              styles.selector,
              usageFrequency === "day" && styles.selected
            )}
          >
            Daily
          </p>
        </span>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            this.props.dispatch(energyActions.setUsageFrequency("week"))
          }
        >
          <p
            className={css(
              styles.selector,
              usageFrequency === "week" && styles.selected
            )}
          >
            Weekly
          </p>
        </span>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            this.props.dispatch(energyActions.setUsageFrequency("month"))
          }
        >
          <p
            className={css(
              styles.selector,
              usageFrequency === "month" && styles.selected
            )}
          >
            Monthly
          </p>
        </span>
      </div>
    );
  }
}
